/**
 * Created by andrey on 10.09.2025
 */

const PortalBase = function (name) {
    Platform.call(this, name);

    connector.social.needWindowForLogin = true;

    this.needsCountry = true;

    const messageHandler = (event) => {
        const data = event.data || {};

        if (connector.config.debugMode && (data.callCallback || data.nativeEvent)) {
            console.log("native message", data);
        }

        if (data.callCallback) {
            this.callCallback(data.method, data.code, data.options, data.callId);
        } else if (data.nativeEvent) {
            this.nativeEvent(data.name, data.data);
        }
    };

    window.addEventListener("message", messageHandler);
};

PortalBase.prototype = Object.create(Platform.prototype);
PortalBase.prototype.constructor = PortalBase;

PortalBase.prototype.getSafePadding = function () {
};

PortalBase.prototype._callNative = function (method, options) {
    window.parent[PortalBase.POST_MESSAGE]({
        callNative: true,
        method,
        options
    }, "*");
};

PortalBase.POST_MESSAGE = "postMessage";